if (!customElements.get('installation-guide-section')) {
  customElements.define(
    'installation-guide-section',
    class InstallationGuideSection extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-installation-guide-link]'));
        this.steps = Array.from(this.querySelectorAll('[data-installation-guide-step]'));

        if (!this.links.length || !this.steps.length) return;

        this.linksById = new Map();
        this.links.forEach((link) => {
          const targetId = link.dataset.installationGuideLink;
          if (targetId) this.linksById.set(targetId, link);
        });

        this.bindActiveState();
      }

      bindActiveState() {
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const visible = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

              if (visible.length) {
                this.setActiveLink(visible[0].target.dataset.installationGuideStep);
                return;
              }

              this.updateActiveLinkFromScroll();
            },
            {
              rootMargin: '-18% 0px -62% 0px',
              threshold: [0, 1]
            }
          );

          this.steps.forEach((step) => this.observer.observe(step));
        }

        this.onScroll = this.updateActiveLinkFromScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateActiveLinkFromScroll();
      }

      updateActiveLinkFromScroll() {
        if (!this.steps.length) return;

        const offset = 170;
        let activeStep = this.steps[0];

        this.steps.forEach((step) => {
          const top = step.getBoundingClientRect().top;

          if (top - offset <= 0) {
            activeStep = step;
          }
        });

        this.setActiveLink(activeStep.dataset.installationGuideStep);
      }

      setActiveLink(id) {
        if (!id) return;

        this.linksById.forEach((link, key) => {
          const isActive = key === id;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}
